import { dataStampSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStampSolid = /*#__PURE__*/createIcon(dataStampSolid)
export default IconStampSolid
